export const HeaderTag = ({ text }: { text: string }) => {
  return (
    <div className="border-1 rounded-[30px] border-transparent bg-gradient-to-r from-[#D8B4E2]/25 to-[#4970FC]/25 p-[1px] bg-clip-border w-fit">
      <div className="bg-white px-[10px] py-[5px] rounded-[30px]">
        <p className="text-[12px] leading-[18px] text-[]">{text}</p>
      </div>
    </div>
  );
};
